// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1XGRb","validationTips":"StatementDescriptor_validationTips__1mKjD"};